import { useEffect } from 'react';
import {
  useCreateMasterDocEtmfMutation,
  useDeleteAllETMFDocsByFileIdMutation,
  useDeleteETMFDocByFileIdMutation,
  useLazyGetAllDocumentsByArtifactnameQuery,
  useLazyGetDocLevelBYArtifactNameQuery,
  useLazyGetTmfLevelQuery,
  useUpdateInlineMaterDocEtmfMutation
} from 'src/services/etmfDocLevel';
import {
  useCreateMasterDocIsfMutation,
  useDeleteAllIsfDocsByFileIdsMutation,
  useDeleteIsfDocByFileIdMutation,
  useLazyGetAllISFDocInfoByArtifactNumberSiteLevelQuery,
  useLazyGetISFDocDetailsByStudyDocumentIdQuery,
  useLazyGetISFDocInfoByLevelTypeArtifactNameQuery,
  useUpdateInlineMaterDocIsfMutation,
  useUploadMasterIsfFileMutation
} from 'src/services/isfDocLevel';
import { useAppDispatch } from 'src/store/hooks';
import { updateUserAccess } from 'src/util/util';

export const useDocumentUploads = () => {
  const dispatch = useAppDispatch();
  const [getISFDocInfoByLevelTypeArtifactNameDataQuery, { error: isfDocInfoByLevelTypeArtifactNameDataError }] =
    useLazyGetISFDocInfoByLevelTypeArtifactNameQuery();

  const [getAllISFDocInfoByArtifactNumberSiteLevelData, { error: allISFDocInfoByArtifactNumberSiteLevelDataError }] =
    useLazyGetAllISFDocInfoByArtifactNumberSiteLevelQuery();

  const [uploadIsfMasterFile, { error: uploadIsfMasterFileDataError }] = useUploadMasterIsfFileMutation();

  const [createMasterDocumentIsf, { error: createMasterDocumentDataIsfError }] = useCreateMasterDocIsfMutation();

  const [createMasterDocumentEtmf, { error: createMasterDocumentDataEtmfError }] = useCreateMasterDocEtmfMutation();

  const [deleteMasterDocumentETMF, { error: deleteMasterDocumentDataETMFError }] = useDeleteETMFDocByFileIdMutation();

  const [deleteAllMasterDocumentsETMF, { error: deleteAllMasterDocumentsDataETMFError }] = useDeleteAllETMFDocsByFileIdMutation();

  const [deleteMasterDocumentIsf, { error: deleteMasterDocumentDataIsfError }] = useDeleteIsfDocByFileIdMutation();

  const [deleteAllMasterDocumentIsf, { error: deleteAllMasterDocumentDataIsfError }] =
    useDeleteAllIsfDocsByFileIdsMutation();
  const [updateInlineMasteDocIsfQuerry, { error: updateInlineMasteDocIsfQuerryDataError }] =
    useUpdateInlineMaterDocIsfMutation();

  const [updateInlineMasteDocEtmfQuerry] = useUpdateInlineMaterDocEtmfMutation();

  useEffect(() => {
    if (
      isfDocInfoByLevelTypeArtifactNameDataError ||
      allISFDocInfoByArtifactNumberSiteLevelDataError ||
      uploadIsfMasterFileDataError ||
      createMasterDocumentDataIsfError ||
      createMasterDocumentDataEtmfError ||
      deleteMasterDocumentDataIsfError ||
      updateInlineMasteDocIsfQuerryDataError ||
      deleteAllMasterDocumentDataIsfError || 
      deleteAllMasterDocumentsDataETMFError
    ) {
      updateUserAccess(
        isfDocInfoByLevelTypeArtifactNameDataError ||
          allISFDocInfoByArtifactNumberSiteLevelDataError ||
          uploadIsfMasterFileDataError ||
          createMasterDocumentDataEtmfError ||
          createMasterDocumentDataIsfError ||
          deleteMasterDocumentDataIsfError ||
          deleteAllMasterDocumentDataIsfError ||
          updateInlineMasteDocIsfQuerryDataError ||
          deleteMasterDocumentDataETMFError || 
          deleteAllMasterDocumentsDataETMFError,
        dispatch
      );
    }
  }, [
    isfDocInfoByLevelTypeArtifactNameDataError,
    allISFDocInfoByArtifactNumberSiteLevelDataError,
    uploadIsfMasterFileDataError,
    createMasterDocumentDataIsfError,
    createMasterDocumentDataEtmfError,
    deleteMasterDocumentDataIsfError,
    updateInlineMasteDocIsfQuerryDataError,
    deleteAllMasterDocumentDataIsfError,
    deleteMasterDocumentDataETMFError
  ]);

  const [getAllDocsByArtifactName] = useLazyGetAllDocumentsByArtifactnameQuery();

  const [getDocLevelByArtifactName] = useLazyGetDocLevelBYArtifactNameQuery();

  const [getTmfLevelQuery] = useLazyGetTmfLevelQuery();

  const [getIsfDocDetailsByStudyDocIdQuerry] = useLazyGetISFDocDetailsByStudyDocumentIdQuery();

  return {
    getISFDocInfoByLevelTypeArtifactNameDataQuery,
    getAllISFDocInfoByArtifactNumberSiteLevelData,
    uploadIsfMasterFile,
    createMasterDocumentIsf,
    createMasterDocumentEtmf,
    deleteMasterDocumentIsf,
    getAllDocsByArtifactName,
    getDocLevelByArtifactName,
    getTmfLevelQuery,
    getIsfDocDetailsByStudyDocIdQuerry,
    updateInlineMasteDocIsfQuerry,
    updateInlineMasteDocEtmfQuerry,
    deleteAllMasterDocumentIsf,
    deleteMasterDocumentETMF,
    deleteAllMasterDocumentsETMF
  };
};
